import axios from 'axios';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import swal from 'sweetalert';
import undefsafe from 'undefsafe';
import CommissionLabel from '../../../components/CommissionLabel';
import SalePackageLabel from '../../../components/SalePackageLabel';
import Button from '../../../components/CustomButton/CustomButton';
import * as K from '../redux/SalesConstants';

class otherServicesSaleAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: '',
        description: '',
        price: 0,
        buyprice: 0,
        operator: '',
      },
      optionsSelect: {
        operators: [],
      },
      edit: '',
    };
  }

  componentWillMount() {
    this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    var newForm = nextProps.Sales.dataToEdit.otherServices;
    this.state.edit = newForm;
    if (newForm.name !== undefined) {
      this.setState({
        formData: newForm,
      });
    }
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    const response = await axios.get(url);

    const options = response.data
      .filter((option) => option.isDeleted !== true)
      .map(optionCreateFunction)
      .sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      formData: {
        name: '',
        description: '',
        price: 0,
        buyprice: 0,
        operator: '',
      },
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'otherServices',
    });
  };

  alertInfo = async (msg) => {
    await swal('Atención!!', msg, {
      icon: 'warning',
      timer: 2500,
      buttons: false,
    });
  };

  handledPrices = () => {
    if (this.formAdd.reportValidity()) {
      this.onAdd();
    }
  };

  onAdd = () => {
    if (this.formAdd.reportValidity()) {
      if (this.state.edit.name !== undefined) {
        this.props.dispatch({
          type: K.UPDATE_SERVICE,
          payload: {
            data: {
              value: this.state.formData,
              index: this.props.Sales.indexToEdit,
            },
          },
        });
        this.props.dispatch({
          type: K.CLOSE_MODAL_ADD,
          payload: 'otherServices',
        });
      } else {
        console.log('add');
        this.props.dispatch({
          type: K.ADD_SERVICE,
          payload: this.state.formData,
        });
        this.props.updateOperators();
        this.props.dispatch({
          type: K.CLOSE_MODAL_ADD,
          payload: 'otherServices',
        });
      }
      this.setState({
        formData: {
          name: '',
          description: '',
          price: 0,
          buyprice: 0,
          operator: '',
        },
      });
    }
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  render() {
    const {
      Sales: {
        modalAddStatus,
        salesInformation: { isPackage = false },
      },
    } = this.props;
    const { formData, optionsSelect } = this.state;

    return (
      <div>
        <Modal
          open={undefsafe(modalAddStatus, 'otherServices') || false}
          onClose={this.onCloseModal}
          styles={{ modal: { width: '100%' } }}
          closeOnOverlayClick={false}
        >
          <form
            ref={(ref) => {
              this.formAdd = ref;
            }}
          >
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <h5>Agregar servicio</h5>
                  <SalePackageLabel isPackage={isPackage} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="name" style={{ fontWeight: '400' }}>
                      NOMBRE DEL SERVICIO
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      value={formData.name}
                      onChange={(event) =>
                        this.onChange('name', event.target.value)
                      }
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="description" style={{ fontWeight: '400' }}>
                      DESCRIPCIÓN
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="description"
                      value={formData.description}
                      onChange={(event) =>
                        this.onChange('description', event.target.value)
                      }
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                      TARIFA NETA
                    </label>
                    <input
                      type="number"
                      min="1"
                      step="any"
                      className="form-control"
                      id="buyprice"
                      value={formData.buyprice}
                      disabled={isPackage}
                      onChange={(event) =>
                        this.onChange('buyprice', event.target.value)
                      }
                    />
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label htmlFor="price" style={{ fontWeight: '400' }}>
                      TARIFA PÚBLICA
                    </label>
                    <input
                      type="number"
                      min="1"
                      step="any"
                      className="form-control"
                      id="price"
                      value={formData.price}
                      disabled={isPackage}
                      onChange={(event) =>
                        this.onChange('price', event.target.value)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <CommissionLabel
                price={formData.price}
                buyprice={formData.buyprice}
                isPackage={isPackage}
              />
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="operator" style={{ fontWeight: '400' }}>
                      OPERADOR
                    </label>
                    <Select
                      validate
                      required
                      placeholder="-- Seleccionar"
                      name="operator"
                      value={
                        (formData.operator && formData.operator._id) ||
                        formData.operator
                      }
                      options={optionsSelect.operators}
                      onChange={(value) => {
                        if (value) {
                          this.onChange('operator', value.value);
                        } else {
                          this.onChange('operator', '');
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={'pull-right'} style={{ marginBottom: 15 }}>
                    <Button
                      bsStyle="primary"
                      style={{ marginRight: 10 }}
                      onClick={this.onCloseModal}
                    >
                      Regresar
                    </Button>
                    <Button bsStyle="primary" fill onClick={this.handledPrices}>
                      Guardar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Grid>
          </form>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(
  otherServicesSaleAdd,
);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/otherServicesSaleAdd.js